import React from 'react';
import PropTypes from 'prop-types';
import '../global-sass/main.scss';

const SuggestionItem = ({
	suggestion,
	index,
	isActive,
	onSelect,
	onMouseEnter,
	onMouseLeave
}) => (
	<li key={suggestion.placePrediction.placeId || index}>
		<button
			type="button"
			className={`btn btn-link px-0 py-2 text-decoration-none text-body suggestion-item ${
				isActive ? 'active' : ''
			}`}
			onClick={() => onSelect(index)}
			onMouseEnter={() => onMouseEnter(index)}
			onMouseLeave={onMouseLeave}
			role="option"
			aria-selected={isActive}
		>
			{suggestion.placePrediction.text.text}
		</button>
	</li>
);

SuggestionItem.propTypes = {
	suggestion: PropTypes.shape({
		placePrediction: PropTypes.shape({
			placeId: PropTypes.string.isRequired,
			text: PropTypes.shape({
				text: PropTypes.string.isRequired
			}).isRequired
		}).isRequired
	}).isRequired,
	index: PropTypes.number.isRequired,
	isActive: PropTypes.bool.isRequired,
	onSelect: PropTypes.func.isRequired,
	onMouseEnter: PropTypes.func.isRequired,
	onMouseLeave: PropTypes.func.isRequired
};

export default SuggestionItem;
